import firebase from '../Firebase/Firebase';
import { appUrl } from '../Config/env';

const stripTrailingSlashes = (value) => String(value || '').replace(/\/+$/, '');

const configuredAppOrigin = () => {
  if (appUrl) {
    try {
      return stripTrailingSlashes(new URL(appUrl).origin);
    } catch (_) {
      // Ignore an invalid optional VITE_APP_URL and use the browser origin below.
    }
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return stripTrailingSlashes(window.location.origin);
  }

  return 'https://lepetitboulot.fr';
};

const isContinueUrlConfigurationError = (error) => [
  'auth/unauthorized-continue-uri',
  'auth/invalid-continue-uri',
  'auth/missing-continue-uri',
].includes(String(error?.code || ''));

export const configureFrenchAuthEmails = () => {
  firebase.auth().languageCode = 'fr';
};

export const emailActionSettings = (continuePath = '/login') => {
  const safePath = String(continuePath || '/login').startsWith('/')
    ? String(continuePath || '/login')
    : '/login';

  return {
    url: `${configuredAppOrigin()}${safePath}`,
    handleCodeInApp: false,
  };
};

/**
 * Sends the verification email using the branded application return URL.
 *
 * If Firebase has not yet authorized the custom domain, retry with Firebase's
 * default action settings. This keeps registration working while the DNS or
 * Authorized domains configuration is being completed.
 */
export const sendVerificationEmail = async (user, continuePath = '/login') => {
  if (!user) throw new Error('Votre session a expiré. Reconnectez-vous.');
  configureFrenchAuthEmails();

  try {
    await user.sendEmailVerification(emailActionSettings(continuePath));
    return { usedDefaultActionSettings: false };
  } catch (error) {
    if (!isContinueUrlConfigurationError(error)) throw error;

    await user.sendEmailVerification();
    return { usedDefaultActionSettings: true };
  }
};

export const sendPasswordReset = async (email, continuePath = '/login') => {
  configureFrenchAuthEmails();
  const normalizedEmail = String(email || '').trim().toLowerCase();

  try {
    await firebase.auth().sendPasswordResetEmail(
      normalizedEmail,
      emailActionSettings(continuePath),
    );
    return { usedDefaultActionSettings: false };
  } catch (error) {
    if (!isContinueUrlConfigurationError(error)) throw error;

    await firebase.auth().sendPasswordResetEmail(normalizedEmail);
    return { usedDefaultActionSettings: true };
  }
};
